import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";

export const uiStateSelector = (state: RootState) => state.ui;

export const uiStatusSelector = createSelector(uiStateSelector, s => s.status);

export const uiSelectors = {
  uiValidatingFields: createSelector(uiStateSelector, s => s.validatingFields),
  uiErrorMessage: createSelector(uiStateSelector, s => s.errorMessage),
  uiErrorCode: createSelector(uiStateSelector, s => s.errorCode),
  uiAlertMessage: createSelector(uiStateSelector, s => s.alert),
  uiIsLoading: createSelector(uiStatusSelector, s => s === "loading"),
  uiHasError: createSelector(uiStatusSelector, s => s === "error"),
  uiIsIdle: createSelector(uiStatusSelector, s => s === "idle"),
  uiCurrentWorkflow: createSelector(uiStateSelector, s => s.currentWorkflow),
  uiErrorData: createSelector(uiStateSelector, s => s.errorData?.data),
  uiRedirectError: createSelector(
    uiStateSelector,
    s => s.errorData?.redirectError,
  ),
  uiLastHttpStatus: createSelector(
    uiStateSelector,
    s => s.lastHttpResponseStatus,
  ),
  uiBlockingError: createSelector(
    uiStateSelector,
    s => typeof s.errorData === "object" && s.errorData.blocking,
  ),
};
